import React from 'react';
import './AlcoholConfigControlWrapper.css';

interface AlcoholConfigControlWrapperProps {
    label: string;
    icon?: string;
}

const AlcoholConfigControlWrapper: React.FC<AlcoholConfigControlWrapperProps> = (props) => {
    const { label, icon } = props;

    return (
        <div className="alcohol-config-wrapper">
            <div className="config-label text">
                <span>{label}</span> {icon && <img className="alco-icon" src={icon} alt="" />}
            </div>
            {props.children}
        </div>
    );
};

export default AlcoholConfigControlWrapper;
